module.exports = __webpack_public_path__ + "img/how_to_plan_a_video_game_splash.52bf7627.jpg";